import { useMemo, useState } from 'react'
import { Pressable, View } from 'react-native'
import Page from '@shell/Page'
import Typography from '@ui/typography'
import ImageNavigation from '@ui/components/ImageNavigation'
import { Image } from 'expo-image'
import { colors } from '@ui/colors'

const getPlaceholderUrl = (index: number) =>
  `https://placehold.co/64x64?text=${encodeURIComponent(`#${index + 1}`)}`

const itemWidth = 128
const itemGap = 32

export default function DevImageNavigationPage() {
  const [currentIndex, setCurrentIndex] = useState(0)

  const items = useMemo(
    () =>
      Array.from({ length: 30 }, (_, index) => ({
        title:
          index % 2 === 0 ? `Image number ${index + 1}` : `Img ${index + 1}`,
        image: {
          id: index + 1,
          url: getPlaceholderUrl(index),
          width: 64,
          height: 64,
          remote: true,
        },
      })),
    []
  )

  return (
    <Page stage="dev">
      <View className="gap-8 p-8">
        <Typography variant="LG">Image Navigation</Typography>
        <ImageNavigation
          currentIndex={currentIndex}
          itemWidth={itemWidth}
          itemGap={itemGap}
        >
          {items.map((item, index) => (
            <Pressable
              key={item.image.id}
              className="flex items-center justify-center border"
              style={{
                width: itemWidth,
                height: itemWidth,
                borderColor:
                  currentIndex === index ? colors.blue[600] : colors.black10,
                borderWidth: currentIndex === index ? 2 : 1,
              }}
              onPress={() => setCurrentIndex(index)}
            >
              <Image
                source={item.image.url}
                style={{ width: 64, height: 64 }}
              />
            </Pressable>
          ))}
        </ImageNavigation>
      </View>
    </Page>
  )
}
